module.exports = __webpack_public_path__ + "img/signcontrol_img.b49ae33d.png";